<ng-container *ngIf="isGroupedQuestion">
  <div class="qus">
    <div class="me-4 qus-label">
      {{ hideOrder ? "" : formTemplateQuestion.order + ". " }}
      <ng-container *ngTemplateOutlet="questionLabel; context: { ftq: formTemplateQuestion }" />
    </div>
    <ng-container *ngTemplateOutlet="questionType; context: { class: 'd-flex p-0' }" />
  </div>
  <div
    *ngIf="service.showErrors && formControl.invalid"
    class="invalid-feedback d-flex justify-content-end pe-2 pb-2"
  >
    Please answer this mandatory question
  </div>
</ng-container>

<ng-container
  *ngIf="
    !isGroupedQuestion &&
    !isQuestionList(formTemplateQuestion) &&
    !isQuestionRank(formTemplateQuestion)
  "
>
  <div *ngIf="!hideOrder" class="no-side">{{ formTemplateQuestion.order }}</div>
  <div class="lavel-side">
    <p>
      <ng-container *ngTemplateOutlet="questionLabel; context: { ftq: formTemplateQuestion }" />
    </p>
    <ng-container *ngTemplateOutlet="questionType" />
  </div>
</ng-container>

<ng-container
  *ngIf="
    !isGroupedQuestion &&
    (isQuestionList(formTemplateQuestion) || isQuestionRank(formTemplateQuestion))
  "
>
  <div class="box">
    <div class="title d-flex">
      {{ hideOrder ? "" : formTemplateQuestion.order + ". "
      }}<ng-container *ngTemplateOutlet="questionLabel; context: { ftq: formTemplateQuestion }" />
    </div>
    <ng-container *ngTemplateOutlet="questionType" />
    <div
      *ngIf="service.showErrors && formControl.invalid"
      class="invalid-feedback d-flex px-2 pb-2"
    >
      Please answer this mandatory question
    </div>
  </div>
</ng-container>

<ng-template #questionType let-class="class">
  <ng-container *ngIf="isQuestionRange(formTemplateQuestion)">
    <app-question-range [class]="class" [question]="formTemplateQuestion" />
    <div *ngIf="service.showErrors && formControl.invalid" class="invalid-feedback d-flex">
      Please answer this mandatory question
    </div>
  </ng-container>
  <ng-container *ngIf="isQuestionNPS(formTemplateQuestion)">
    <app-question-nps [class]="class" [question]="formTemplateQuestion" />
    <div *ngIf="service.showErrors && formControl.invalid" class="invalid-feedback d-flex">
      Please answer this mandatory question
    </div>
  </ng-container>
  <ng-container *ngIf="isQuestionList(formTemplateQuestion)">
    <app-question-list [class]="class" [question]="formTemplateQuestion" />
  </ng-container>
  <ng-container *ngIf="isQuestionRank(formTemplateQuestion)">
    <app-question-rank [class]="class" [question]="formTemplateQuestion" />
  </ng-container>
  <ng-container *ngIf="isQuestionText(formTemplateQuestion)">
    <app-question-text [class]="class" [question]="formTemplateQuestion" />
    <div *ngIf="service.showErrors && formControl.invalid" class="invalid-feedback d-flex">
      Please answer this mandatory question
    </div>
  </ng-container>
  <ng-container *ngIf="isQuestionDate(formTemplateQuestion)">
    <app-question-date [class]="class" [question]="formTemplateQuestion" />
    <div *ngIf="service.showErrors && formControl.invalid" class="invalid-feedback d-flex">
      <ng-container *ngIf="formControl.hasError('required'); else dateFormatError">
        Please answer this mandatory question
      </ng-container>
      <ng-template #dateFormatError> Please enter a valid date in DD/MM/YYYY format </ng-template>
    </div>
  </ng-container>
  <ng-container *ngIf="isQuestionNumeric(formTemplateQuestion)">
    <app-question-numeric [class]="class" [question]="formTemplateQuestion" />
    <div *ngIf="service.showErrors && formControl.invalid" class="invalid-feedback d-flex">
      Please answer this mandatory question
    </div>
  </ng-container>
</ng-template>

<ng-template #questionLabel let-question="ftq">
  <span class="question-label-content" [innerHTML]="question.value | safeHtml"></span>
  <span *ngIf="question.required" class="required-asterisk">*</span>
  <div class="ms-1 multi-line" [innerHTML]="question.note | safeHtml"></div>
</ng-template>
